/** Conductor material editor (applied to both conductors). */
import { CONDUCTOR_PRESETS, condFromPreset } from "../model/materials";
import { design, updateDesign } from "../state/store";
import { NumberField, Select } from "./common";

export function ConductorPanel() {
  const c = design.value.conductor;
  return (
    <div class="param-form">
      <Select
        label="Conductor"
        value={c.presetId ?? "custom"}
        options={[...CONDUCTOR_PRESETS.map((p) => ({ value: p.id, label: p.name })), { value: "custom", label: "Custom" }]}
        onChange={(id) => {
          if (id !== "custom") updateDesign((d) => ({ ...d, conductor: condFromPreset(id) }));
        }}
      />
      <NumberField
        label="σ"
        unit="S/m"
        path="conductor.sigma"
        step={1e6}
        min={0}
        value={c.sigma}
        onChange={(sigma) => updateDesign((d) => ({ ...d, conductor: { ...d.conductor, sigma, presetId: undefined } }))}
      />
      <NumberField
        label="Roughness Rq"
        unit="µm"
        step={0.1}
        min={0}
        value={c.roughnessUm}
        onChange={(roughnessUm) => updateDesign((d) => ({ ...d, conductor: { ...d.conductor, roughnessUm } }))}
      />
      {c.roughnessUm > 0 && (
        <Select
          label="Roughness model"
          value={c.roughnessModel}
          options={[
            { value: "hammerstad", label: "Hammerstad" },
            { value: "gradient", label: "Gradient (Gold-Helmreich)" },
          ]}
          onChange={(roughnessModel) => updateDesign((d) => ({ ...d, conductor: { ...d.conductor, roughnessModel } }))}
        />
      )}
    </div>
  );
}
